// extracted by mini-css-extract-plugin
export default {"map":"map_map__24tmI","content":"map_content__QSAxi"};